import { ApiResponse } from 'apisauce';
import { AvailabilityEnum } from '../../../products/ProductTypes';
import { CatalogAvailabilityConditions, CatalogSectionCount } from '../../catalog.types';
import { CatalogSectionSortCriterionEnum } from '../../enums/catalogSectionSortCriterion.enum';
import { CriteriaOperatorEnum } from '../../enums/criteriaOperator.enum';
import { NavigationColorMode } from '../../enums/navigationColorMode.enum';
import { CatalogCardVariantKey } from '../../products/v2/sizing/catalogCardColumns.types';
import { CatalogViewGroupBy, CatalogViewMode } from '../../products/v2/view/catalogView.types';

export type OfflineSectionProductSet = ReadonlySet<string>;

export const EMPTY_OFFLINE_SECTION_PRODUCT_SET: OfflineSectionProductSet = new Set();

interface GetCatalogSectionsBaseResponse {
  sectionsResponse: ApiResponse<CatalogSectionCount[], CatalogSectionCount[]>;
}

export interface GetCatalogSectionsOnlineOutput extends GetCatalogSectionsBaseResponse {}

export interface GetCatalogSectionsOfflineOutput extends GetCatalogSectionsBaseResponse {
  offlineSectionProductSet: OfflineSectionProductSet;
}

export type GetCatalogSectionsOutput =
  | GetCatalogSectionsOnlineOutput
  | GetCatalogSectionsOfflineOutput;

export enum ErrorTypeEnum {
  INITIAL_DATE = 'INITIAL_DATE',
  END_DATE = 'END_DATE',
}

export type CatalogRestrictionEntityErrorType = ErrorTypeEnum[] | null;

export interface CatalogRestrictionDatesErrors {
  customers: CatalogRestrictionEntityErrorType;
  salesRepresentative: CatalogRestrictionEntityErrorType;
  classificationPermissions: CatalogRestrictionEntityErrorType;
}

export interface UpdateCatalogNavigationPreferencesParams {
  navigationColorMode?: NavigationColorMode | null;
  navigationAvailabilities?: AvailabilityEnum[];
  navigationFilterRelatedProducts?: boolean;
  navigationDeliveryWindowIds?: string[];
}

export interface UpdateCatalogParams {
  name?: string;
  code?: string;
  active?: boolean;
  liveLink?: string | null;
  ribbonBannerUrls?: string[];
  ribbonBannerMobileUrls?: string[];
  startDate?: string | null;
  endDate?: string | null;
  enablePublicSharing?: boolean;
  availabilityConditions?: CatalogAvailabilityConditions | null;
  showUnavailableProductsForSale?: boolean;
  withMedia?: boolean;
  groupColorsInSingleCard?: boolean;
  availability?: AvailabilityEnum[];
  collections?: string[];
  classifications?: string[];
  availabilityCriteriaOperator?: CriteriaOperatorEnum;
  classificationCriteriaOperator?: CriteriaOperatorEnum;
}

export interface UpdateCatalogViewPreferencesParams {
  viewMode?: CatalogViewMode;
  viewCardSize?: CatalogCardVariantKey;
  viewGroupBy?: CatalogViewGroupBy;
  sectionSortCriterion?: CatalogSectionSortCriterionEnum;
  sortTargetId?: string | null;
  viewGroupTargetId?: string | null;
  shouldFreezeCurrentArrangement?: boolean;
}

export type GetSellInPriceRangeOutput = {
  min: number | null;
  max: number | null;
};

export interface GetSellInPriceRangeParams {
  orderId?: string;
  priceTableId?: string;
  isAdminSeller: boolean;
}

export interface BatchUpdateCatalogSectionsParams {
  sections: Array<{ id?: string; name: string }>;
}
